
class ApiSpecGroup { 

}

export default ApiSpecGroup;


